import { FlowMessengerNodeAvailabilityStrategy } from 'components/settings/components/sections/dixaMessenger/views/flow/flow.types';

export const availabilityOptionNames: Record<
  FlowMessengerNodeAvailabilityStrategy,
  string
> = {
  alwaysAvailable: 'Always available',
  neverAvailable: 'Never available',
  noAgentsAvailable: 'When all agents are at capacity, away, or offline.',
};

interface AvailabilityOptions {
  id: FlowMessengerNodeAvailabilityStrategy;
  name: string;
}

export const availabilityOptions: AvailabilityOptions[] = [
  {
    id: FlowMessengerNodeAvailabilityStrategy.AlwaysAvailable,
    name: availabilityOptionNames.alwaysAvailable,
  },
  {
    id: FlowMessengerNodeAvailabilityStrategy.NeverAvailable,
    name: availabilityOptionNames.neverAvailable,
  },
  {
    id: FlowMessengerNodeAvailabilityStrategy.NoAgentsAvailable,
    name: availabilityOptionNames.noAgentsAvailable,
  },
];
